class Lang {

    constructor(all = true) {
        this.listeners = [];
        this.data = {
            en: {
                trends_top_destinations: {
                    title: "What's Hot!",
                    title_description: "Top Vacation Countries for all over the world as per recent search.",
                    sun: "Sun",
                    others: "Others"
                },
                trends_top_hotels_tgdests: {
                    title: "TravelBrands Top 10",
                    title_description: "Latest Hotels, Attractions and Packages",
                    hotels: "Hotels",
                    attractions: "Attractions",
                    tgpackages: "TG Packages"
                },
                trends_top_suquests: {
                    title: "Sunquest trending now",
                    title_description: "Explore Sunquest's Top 5s searched in last 48 hours.",
                    destinations: "Top Destination",
                    hotels: "Top Hotel",
                    durations: "Top Duration"
                },
                trends_top_cruises: {
                    title: "Explore the top Cruise categories",
                    title_description: "Currently trending in cruise destination, cruise line and cruise ship.",
                    destinations: "Top Cruise Destination",
                    lines: "Top Cruise Line",
                    ships: "Top Cruise Ship",
                    from: "From",
                    direct: "Direct"
                },
                trends_top_airdestinations: {
                    title: "Top 5 Air Destinations"
                },
                lujure: {
                    INQUIRE_NOW: 'INQUIRE NOW',
                    YOUR_NAME: 'YOUR NAME ',
                    CONTACT_INFO: 'CONTACT INFO ',
                    TRAVEL_INFO: 'TRAVEL INFO ',
                    DESCRIPTION: 'DESCRIPTION ',
                    of_Adults: '# of Adults',
                    of_Childrens: '# of Childrens',
                },
                recent: {
                    check_prices: 'Check Price',
                    social_sharing: 'Social Sharing',
                },
                images: {
                    vacations_no_image: 'https://s3.amazonaws.com/itravel2000/img/no-image/image-not-available-538x190.jpg',
                },
                buttons: {
                    searching: 'Searching',
                    clear_all: 'Clear all',
                    more: 'More',
                    less: 'Less',
                    search: 'Search',
                    apply: 'Apply',
                    cancel: 'Cancel',
                    book_now: 'Book Now',
                    search_best_deals: 'Search Now',
                    check_prices: 'Check Prices',
                    show_advanced: 'Select multiple destinations',
                    buy_now: 'Buy Now',
                },
                customer: {
                    title: 'Title',
                    firstName: 'First Name',
                    middleName: 'Middle Name',
                    lastName: 'Last Name',
                    phone: 'Phone Number',
                    email: 'Email',
                    phoneNumber: 'Phone',
                },
                billing: {
                    ccNumber: 'Credit Card Number',
                    ccName: 'Credit Card Name',
                    ccExpiry: 'Expiry Date',
                    ccCVV: 'CVV',
                    address: 'Billing Address',
                    city: 'Billing City',
                    country: 'Billing Country',
                    province: 'Billing Province/State',
                    postalZip: 'Billing Postal/Zip',
                },
                shipping: {
                    firstName: 'First Name',
                    middleName: 'Middle Name',
                    lastName: 'Last Name',
                    phone: 'Phone Number',
                    address: 'Shipping Address',
                    city: 'Shipping City',
                    country: 'Shipping Country',
                    province: 'Shipping Province/State',
                    postalZip: 'Shipping Postal/Zip',
                },
                gift_cards: {
                    giftcard: 'Gift Card',
                    required: 'is required',
                    secured_by: 'secured by',
                    canada: 'Canada',
                    usa: 'United States',
                    shipping_address: 'Shipping Address',
                    shipping_different: 'Shiping address is different from the billing address',
                    state: 'State',
                    province: 'Province',
                    select: 'select',
                    thank_you_message: 'Thank you for booking with redtag.ca!',
                    please_wait: 'Please wait while we process your request.',
                    purchasing: 'Purchasing Gift Card',
                    processing: 'Processing...',
                    payment_information: 'Payment Information',
                    customer_information: 'Customer Information',
                    cc_information: 'Credit Card Information',
                    price_summary: 'Price Summary',
                    total_price: 'Total Price',
                    recommended: 'Recommended',
                    termsAgreed: 'Please agree to the terms before clicking submit.',
                },
                error_gift_cards: {
                    max2000: 'We\'re sorry! It appears your gift card purchase total exceeds our maximum amount of $2,000.00 for an online purchase. Please call our Customer Care team at 1-866-573-3824 to complete your purchase.',
                    ccNumber: 'Invalid credit card expiry month',
                },
                engine: {
                    filters: 'Filters',
                    nights_date: "Nights",
                    travel_deals: 'Travel Deals',
                    enter_occupancy: 'PLEASE ENTER YOUR OCCUPANCY DETAILS',
                    what_are_child_ages: 'What are the ages of the children at the time of departure?',
                    enter_date: 'Enter Date',
                    departure_date: 'Departure Date',
                    departing: 'Departing',
                    adults: 'Adults',
                    cars: 'Cars',
                    child_age_upon_return: "Child's age upon return",
                    children: 'Children',
                    child: 'child',
                    cruises: 'Cruises',
                    days: 'days',
                    depart: 'Depart',
                    flights: 'Flights',
                    from: 'From',
                    guests: 'Guests',
                    hotels: 'Hotels',
                    hotel: 'Hotel',
                    destination: 'Destination',
                    loading: 'Loading...',
                    nights: 'nights',
                    or: 'or',
                    return: 'Return',
                    roomLabel: ':number Room:plural',
                    adultLabel: ':number Adult:plural',
                    childrenLabel: ':number Children',
                    rooms: 'Rooms',
                    room: 'Room',
                    to: 'to',
                    to_upper: 'To',
                    vacations: 'Vacations',
                    destinations: 'Destinations',
                    all: 'All',
                    stars: 'Stars',
                    was: 'was',
                    save: 'save',
                    packages: 'Packages',
                    flight_hotel: 'Flight + Hotel',
                    please_wait: 'Finding you the best prices...',
                    select: 'Select',
                    and: 'and',
                    promoCode: 'Promo Code',
                    enter_code: 'Enter code',
                    advanceSearch: 'Advance Search',
                    multipleDestination: 'Multiple destination vacation planner',
                    addons: 'Add-ons',
                    destination_placeholder: 'Search by city',
                    additionalFlightFilter: 'Additional Flight Filter',
                    additionalHotelFilter: 'Additional Hotel Filter',
                    include_baggage: "Include Free baggage",
                    exclude_connections: "Exclude Overnight Connections",
                    exclude_economy: "Exclude Basic Economy",
                    exclude_non_ref_flights: "Exclude NonRefundable Flights",
                    exclude_non_charge_flights: "Exclude NonChangable Flights",
                    city_hotel_name: "Enter city or hotel name",
                    additionalCarFilter: 'Additional Car Filter',
                    clear: 'Clear',
                    clients: "guests",
                    enter_more_characters: "Enter one or more characters",
                    no_records_found: "No records found",
                    select_travel_dates: "Please select your travel dates",
                    date_format: 'DDMMMYY',
                    learn_more: 'Learn more!',
                    new: 'New!',
                    gigi_tool:'Try GIGI',
                    current_air_tool:'Current Air Tool',
                    flights_cad:'Flights CAD',
                    flights_usd:'Flights USD',
                    max_adult_allow: 'You can select upto 12 adults only',
                    max_child_allow: 'You can select upto 6 children only',
                    max_adult_child_allow: 'You can select upto 12 adults and 6 children only',
                    days_left_to_bye: "Days left to say goodbye👋🏻"
                },
                engine_travelgenie: {
                    title: 'TravelGenie',
                    flight_hotel: 'Flight + Hotel',
                    flight_car: 'Flight + Car',
                    from: 'Departing from',
                    to: 'Going to',
                    departure: 'Departure',
                    return: 'Return',
                    cabin: 'Class',
                    roomsnguest: 'Rooms & Guests',
                    departure_placeholder: "Enter airport code or city",
                    of_nights: "of Nights",
                    airline: "Airline",
                    airline_placeholder: "Select a Airline",
                    number_of_stops: "Number of stops",
                    depart_time: "Depart time",
                    select_time: "Select Time",
                    return_time: "Return time",
                    hotel_placeholder: "Select a hotel",
                    chain: "Chain",
                    chain_placeholder: "Select a chain",
                    booking_an_infant: "Booking an Infant",
                    adults_children: "Adults & Children",
                    adults_and_children: "Adults and Children",
                    adults: "Adults",
                    children: "Children",
                    booking_an_infant_pera: "Booking an InfantPassengers under the age of 2 for the duration of the holiday are considered infants and may fly free of charge (1 infant per adult allowed). A reservation however is required for each infant. Please note that infants are not assigned a seat and are not allotted baggage allowance. If an infant turns 2 years of age during the vacation, an airline ticket must be purchased for their travel to and from the destination. Certain fees may apply.",
                    select_a_departure: "Select a departure",
                    select_a_destination: "Select a destination",
                    please_select_a_valid_departure_and_return_date: "Please select a valid departure and return date",
                    please_select_a_valid_departure_date: "Please select a valid departure date",
                    hrs_error_for_departure_date: "Departures within 48hrs, please contact our Call Centre to book.",

                },
                engine_cars: {
                    pickup_time: 'Pick up<br/>Time',
                    dropoff_time: 'Drop off<br/>Time',
                    pickup_location: 'Pick up<br/>Location',
                    dropoff_location: 'Drop off<br/>Location',
                    afternoon: 'Afternoon',
                    different_dropoff: 'Different Dropoff?',
                    dropoff: 'Dropoff',
                    dropoff_date: 'Drop-off<br />Date',
                    morning: 'Morning',
                    pickup: 'Pickup',
                    enter_pickup: 'Enter your pickup location',
                    pickup_date: 'Pick-up<br />Date',
                    evening: 'Evening',
                    car_gross: 'Car Gross',
                    car_net: 'Car Net',
                    car_company: 'Car Company',
                    car_pickup: 'Pick Up',
                    car_dropoff: 'Drop Off',
                },
                engine_cruises: {
                    cruise_length: 'Cruise<br/>Length',
                    departure_port: 'Departure<br/>Port',
                    all_destinations: 'All Destinations',
                    all_months: 'All Months',
                    all_vendors: 'All Cruise Lines / Ships',
                    any_duration: 'Any Length',
                    any_port: 'Any Port',
                    destinations: 'Going to',
                    ports: 'Ports',
                    vendors: 'Cruise Line / Ship',
                    month: 'Month',
                    year: 'Year',
                    ocean: 'Ocean',
                    river: 'River',
                    destination: 'Destination',
                    start: 'Start',
                    end: 'End',
                    duration: 'Duration',
                    cruiseLine: 'Cruise Line',
                    cruiseShip: 'Cruise Ship',
                    embarkationPort: 'Embarkation Port',
                    destination_placeholder: 'Select a location',
                    cruiseLine_placeholder: 'Select a cruise line',
                    cruisePort_placeholder: 'Select a embarkation port',
                    cruiseShip_placeholder: 'Select a ship',
                    cabins: "of Cabins",
                    nights_one_two: "1-2 nights",
                    nights_three_six: "3-6 nights",
                    nights_seven_nine: "7-9 nights",
                    nights_ten_fourteen: "10-14 nights",
                    nights_fifteen_plus: "15+ nights",
                    any_lenth: "Any Length"

                },
                engine_flights: {
                    class_first: 'First Class',
                    class_business: 'Business Class',
                    class_economy: 'Economy',
                    class_premium_economy: 'Premium Economy',
                    depart: 'Depart',
                    direct_flight: 'Direct Flight',
                    multi_city: 'Multi City',
                    nearby_airports: 'Nearby Airports',
                    one_way: 'One Way',
                    return: 'Return',
                    round_trip: 'Round Trip',
                    from_placeholder: 'Enter City or Airport',
                    to_placeholder: 'Enter City or Airport',
                    enter_date: 'Enter Date',
                    add_flight: 'Add a flight',
                    remove_flight: 'Remove last flight',
                    multi_city_flight_from: 'Multi city flight from',
                },
                engine_hotels: {
                    gross: 'Gross',
                    net: 'Net',
                    vacation_rental: "Vacation Rentals",
                    depart: 'Check-In',
                    destination: 'Enter Destination',
                    return: 'Check-Out',
                },
                engine_vacations: {
                    advanced_destination_selection: 'Select Destinations',
                    select_destination_departing_from: 'Select Destination Departing from',
                    select_destination: 'Select a Destination',
                    filter_placeholder: 'Type here to filter search',
                    seat_selection: 'FREE Seat Selection',
                    book_deposit: 'Book with Deposit',
                    per_guest: 'per guest',
                    includes_taxes: 'includes taxes & fees',
                    rooms: 'Rooms',
                    clients: 'Clients',
                    departure_date: 'Departure date',
                    departing_from: 'Departing from',
                    going_to: 'Going to',
                    modify_search: 'Modify your search',
                    all_inclusive_only: 'All Inclusive Only',
                    depart: 'Depart',
                    loading: 'Loading...',
                    destination_placeholder: 'Please select a destination or hotel',
                },
                engine_sunquest: {
                    selectDate: 'Select Date',
                    howLong: 'How Long',
                    destination_placeholder: "Select a location",
                    please_select_a_valid_departure_date:"Please select a valid departure date",
                },
                engine_packages: {
                    flight_hotel: 'Flight + Hotel',
                    flight_hotel_car: 'Flight + Hotel + Car',
                    flight_car: 'Flight + Car',
                    hotel_car: 'Hotel + Car',
                },
                error: {
                    childAges: 'Please enter an age for child :number',
                    date: 'Please select a date',
                    departure: 'Please select a departure',
                    destination: 'Please select a destination',
                    invalid_dates: 'Return date should be greater than departure date',
                    please_select_a_valid_departure_and_return_date:'Please select a valid departure and return date',
                },
                error_cars: {
                    dropoff: 'Please select a dropoff Location',
                    dropoff_date: 'Please select a dropoff Date',
                    pickup: 'Please select a Pickup Location',
                    pickup_date: 'Please select a Pickup Date',
                },
                error_cruises: 'error_cruises',
                error_flights: {
                    return_date: 'Please select a return date',
                    travel_date: 'Please select a travel date',
                },
                error_groups: {
                    your_name: 'Please enter your Name',
                    your_email: 'Please enter a valid Email Address',
                    your_phone: 'Please enter your Phone Number',
                    your_vacation_type: 'Please select a Vacation Type',
                    your_city: 'Please select a departure City',
                },
                error_hotels: {
                    checkin_date: 'Please enter a Check-in Date',
                    checkout_date: 'Please enter a Check-out Date',
                    childAges: 'Please enter an age for child :number in room :room',
                    destination: 'Please select a Destination',
                },
                error_vacations: {
                    adultsEven: 'Sorry, the adult occupancy must be consistent for all rooms in an online booking.',
                    depart: 'Depart is required',
                    fivePerRoom: 'Sorry, you cannot book more than 5 people in one room.',
                    from: 'From is required',
                    moreThenSix: 'Sorry, you can only book a maximum of 6 passengers in an online booking.',
                    multiRoomNoChildren: 'Sorry, you cannot book children with multiple rooms. Please call for all inquiries.',
                    to: 'To is required',
                },
                bpc: {
                    best_price_calendar: 'Best Price Calendar',
                    new: 'New!',
                    lowest_price_calendar: 'Lowest Price Calendar',
                    flexible: 'Flexible with your itinerary?',
                    compare_dates: 'Compare dates, destinations and resorts to find the best time to travel!',
                    select_month: 'Select a Month',
                    search_heading: 'Search Our Best Price Calendar',
                    compare_by_resorts: 'Compare by resorts instead',
                    check_uncheck_all: 'check/uncheck all',
                    filter_by: 'Filter by',
                    filter_stars: 'Filter Stars',
                    filter_resorts: 'Filter Resorts',
                    search_for_best: 'Search for the best prices',
                    all_inclusive: 'All Inclusive',
                    direct_flight: 'Direct Flight',
                    family_friendly: 'Family Friendly',
                    adults_only: 'Adults Only',
                    luxury: 'Luxury',
                    beach_front: 'Beach Front',
                    oceanview: 'Oceanview',
                    golf_course: 'Golf Course',
                    kitchenette: 'Kitchenette',
                    miniclub: 'Miniclub',
                    casino: 'Casino',
                    spa: 'Spa',
                    wedding: 'Wedding Service',
                    classic_view: 'Classic View',
                    show_filters: 'Show Filters',
                    hide_filters: 'Hide Filters',
                    shopping_later: 'Want to continue shopping later? Save these searches to your email',
                    duration: 'Duration',
                    star_rating: 'Star Rating',
                    package_options: 'Package Options',
                    departure_dates: 'Departure Dates',
                    your_resorts: 'Your resorts',
                    compare_five: 'You may compare prices for up to five resorts',
                    departure_month: 'Departure Month',
                    per_person: 'per person, incl. taxes and fees.',
                    list_view: 'List View',
                    calendar_view: 'Calendar View',
                    no_results: 'There are no results. Please try a different search.',
                    filter: 'Filter',
                    no_departures: 'No Departures',
                },
                mealDescription: {
                    AI: 'All meals, snacks included daily, unlimited Beverages (Alcoholic and Non-Alcoholic)',
                    AAI: 'Specific to resort and MAY include 3 meals a day, snacks and limited drinks, no other activities',
                    EP: 'No Meals or Drinks',
                    BP: 'Only Breakfast Available',
                    MAP: 'Breakfast and Dinner Only',
                    FAP: 'Breakfast, Lunch and Dinner only',
                    FCTC: 'All meals, snacks included daily, unlimited Beverages (Alcoholic and Non-Alcoholic)',
                    PO: 'Only Breakfast Available',
                    PE: 'No Meals or Drinks',
                },
                mealContext: {
                    AI: 'All Inclusive',
                    AAI: 'Almost All Inclusive',
                    EP: 'No Meals/Drinks',
                    BP: 'Only Breakfast',
                    MAP: 'Breakfast and Dinner Only',
                    FAP: 'Breakfast, Lunch and Dinner only',
                    FCTC: 'All Inclusive',
                    PO: 'Only Breakfast',
                    PE: 'No Meals/Drinks',
                },
                groups: {
                    comments: 'Comments',
                    request_quote: 'Request Quote',
                    duration_of_stay: 'Duration<br/>of Stay',
                    destination_city: 'Destination<br/>City',
                    departure_city: 'Departure<br/>City',
                    vacation_type: 'Vacation<br/>Type',
                    phone: 'Phone',
                    name: 'Name',
                    email: 'Email',
                    name_placeholder: 'Your Name',
                    email_placeholder: 'Your Email',
                    phone_placeholder: 'Phone Number',
                    get_quote: 'Get a Group Quote',
                    group: 'Group',
                    group_label: 'Groups',
                    leisure: 'Leisure',
                    golf: 'Golf',
                    reunion: 'Reunion',
                    corporate: 'Corporate',
                    wedding: 'Wedding',
                    vow_renewal: 'Vow Renewal',
                    your_comments: 'Your Comments',
                    book_group: 'Click below button to book a group',
                    book_button: 'Book a group'
                },
                dynamic: {
                    area_label: 'Areas',
                    airport_label: 'Airports',
                    city_label: 'Cities',
                    other_label: 'Other',
                },
                loadingModel: {
                    please_wait: 'Please wait',
                    we_are_processing: 'We are processing your request.',
                },
                weekOpenDays: {
                    open: 'Open ',
                    close: 'Close ',
                    closed: 'Closed ',
                    Closes: 'Closes',
                },
                callcenter: {
                    booking_on_behalf_of: 'Booking on behalf of:',
                    type_agency_here: 'Type Agency Here...',
                    select_agent_here: 'Select Agent Here...',
                    no_agent_found: 'No agent found',
                    searching: 'searching...',
                    do_you_want_to: 'Do you want to make booking on behalf of',
                    ok: 'OK',
                    CANCEL: 'CANCEL',
                    fetching_data: 'Fetching Data...',
                    high_risk_agency: 'High risk agency - CC only',
                },
                edocs: {
                    edocs_and_e_invoices: 'e-Docs and e-Invoices',
                    edocs_merit_golf_ski: 'Edocs / Invoices - Merit Golf and Ski',
                    please_be_advised: 'Please be advised that even though your file is confirmed, it is not guaranteed until we receive full payment in our office. You will not be able to access your client’s documents until payment is received',
                    edocs_are_available: 'Edocs are available 45 days prior to departure as long as file is paid in full.',
                    last_minute_bookings: 'Last minute bookings may take up to 24 hours to be available.',
                    if_you_have_made: 'If you have made a change to a booking and require new edocs please note that the edoc icon will be greyed out until new docs are ready for print.',
                    if_your_file_meets: 'If your file meets the above parameters and you are not able to access your edocs, please email ',
                    booking_number: "Booking Number",
                    lead_pax_name: "Lead PAX Name",
                    Please_fill: "Please fill the Booking Number or Lead PAX Name",
                    booking_date_from: "Booking Date From",
                    booking_date_to: "Booking Date To",
                    departure_date_from: "Departure Date From",
                    departure_date_to: "Departure Date To",
                    valid_date: "Please fill the valid Date",
                    search: 'Search',
                    or: 'OR',
                    lead_pax_last_name: "Enter Lead PAX Last Name",
                    tb_booking_number: "Enter TravelBrands Booking Number",
                    enter_agency_number: "Enter Agency Phone",
                    agency: "Agency",
                    fill_agency_phone: "Please Fill The Agency Phone",
                    origin: "Origin",
                    enter_origin: "Enter Origin",
                    destination: "Destination",
                    enter_destination: "Enter Destination",
                    booking: "Booking",
                    username: "Username",
                    departure_date: "Departure date",
                    e_invoice_english: "E-Invoice English",
                    e_invoice_french: "E-Invoice French",
                    e_ticket: "E-ticket",
                    rows_per_page: "Rows per page",
                    no_record: "There are no records to display",
                    oops_message: "Oops! something went wrong. Please try again later.",
                    email_success: "Mail has been sent successfully!",
                }
            },
            fr: {
                trends_top_destinations: {
                    title: "Quoi de neuf ?",
                    title_description: "Top Vacation Countries pour le monde entier selon une recherche récente.",
                    sun: "Soleil",
                    others: "Autres"
                },
                trends_top_hotels_tgdests: {
                    title: "Le Top 10 de TravelBrands",
                    title_description: "Hôtels, attractions et forfaits les plus récents",
                    hotels: "Hôtels",
                    tgpackages: "Paquets TG"
                },
                trends_top_suquests: {
                    title: "Sunquest a le vent en poupe",
                    title_description: "Découvrez le Top 5 des recherches effectuées par Sunquest au cours des dernières 48 heures.",
                    destinations: "Top Destination",
                    hotels: "Top Hôtel",
                    durations: "Top Durée"
                },
                trends_top_cruises: {
                    title: "Découvrez les principales catégories de croisières",
                    title_description: "Les tendances actuelles concernent les destinations de croisière, les compagnies de croisière et les navires de croisière.",
                    destinations: "Destination de croisière privilégiée",
                    lines: "Première ligne de croisière",
                    ships: "Meilleur navire de croisière",
                    from: "Depuis",
                    direct: "Direct"
                },
                trends_top_airdestinations: {
                    title: "Les 5 meilleures destinations aériennes"
                },
                lujure: {
                    INQUIRE_NOW: 'RENSEIGNEZ-VOUS MAINTENANT',
                    YOUR_NAME: 'VOTRE NOM ',
                    CONTACT_INFO: 'INFO CONTACT ',
                    TRAVEL_INFO: 'INFO VOYAGE ',
                    DESCRIPTION: 'DESCRIPTION ',
                    of_Adults: "# de adultes",
                    of_Childrens: '# de Childrens',
                },
                recent: {
                    check_prices: 'Vérification du prix',
                    social_sharing: 'Partage sur les réseaux sociaux',
                },
                images: {
                    vacations_no_image: 'https://s3.amazonaws.com/itravel2000/img/no-image/image-not-available-538x190.jpg',
                },
                groups: {
                    comments: 'Commentaires',
                    request_quote: 'Demandez un devis',
                    duration_of_stay: 'La durée <br/>du séjour',
                    destination_city: 'Ville de<br/>destination',
                    departure_city: 'Ville de<br/>départ',
                    vacation_type: 'Type de<br/>vacances',
                    phone: 'Téléphone',
                    name: 'Nom',
                    email: 'E-mail',
                    name_placeholder: 'Votre nom',
                    email_placeholder: 'Votre e-mail',
                    phone_placeholder: 'Numéro de téléphone',
                    get_quote: 'Obtenir un devis de groupe',
                    group: 'Voyages de groupe',
                    group_label: 'Groupes',
                    leisure: 'Loisir',
                    golf: 'Golf',
                    reunion: 'Réunion',
                    corporate: 'Voyages d\'affaires',
                    wedding: 'Mariages à destination',
                    vow_renewal: 'Renouvellement de vœux',
                    your_comments: 'Vos commentaires',
                    book_group: 'Cliquez sur le bouton ci-dessous pour réserver un groupe',
                    book_button: 'Réserver un groupe'
                },
                buttons: {
                    searching: 'Searching',
                    clear_all: 'Effacer tout',
                    more: 'Plus',
                    less: 'Moins',
                    search: 'Recherche',
                    apply: 'Appliquer',
                    cancel: 'Annuler',
                    book_now: 'Réserver maintenant',
                    search_best_deals: 'Recherchez',
                    check_prices: 'Vérifier les prix',
                    show_advanced: 'Recherche avancée',
                    buy_now: 'Acheter maintenant',
                },
                customer: {
                    mr: 'M.',
                    ms: 'Melle',
                    mrs: 'Mme',
                    title: 'Titre',
                    firstName: 'Prénom',
                    middleName: 'Second Prénom',
                    lastName: 'Nom de famille',
                    phone: 'Numéro de téléphone',
                    email: 'Courriel',
                    phoneNumber: 'Téléphone',
                },
                billing: {
                    ccNumber: 'Numéro de Carte de Crédit',
                    ccName: 'Nom du titulaire de carte de crédit',
                    ccExpiry: 'Date d’expiration',
                    ccCVV: 'CVV',
                    address: 'Adresse de facturation',
                    city: 'Ville  de facturation',
                    country: 'pays de facturation',
                    province: 'Province/état',
                    postalZip: 'Code postal',
                },
                shipping: {
                    firstName: 'Prénom',
                    middleName: 'Second Prénom',
                    lastName: 'Nom de famille',
                    phone: 'Numéro de téléphone',
                    address: 'L’adresse de livraison',
                    city: 'Ville de livraison',
                    country: 'Pays de livraison',
                    province: 'Province/état de livraison',
                    postalZip: 'Code postal de livraison',
                },
                gift_cards: {
                    giftcard: 'Carte-cadeau',
                    required: 'est requis',
                    secured_by: 'Sécurisé',
                    canada: 'Canada',
                    usa: 'United States',
                    shipping_address: 'L’adresse de livraison',
                    shipping_different: 'L’adresse de livraison et l’adresse de facturation sont différentes.',
                    state: 'état',
                    province: 'Province',
                    select: 'Sélectionnez',
                    select_province: 'Sélectionnez la Province',
                    thank_you_message: 'Merci d’avoir acheté votre carte-cadeau à itravel2000.com!',
                    please_wait: 'Merci de patienter pendant que nous traitons votre demande.',
                    purchasing: 'Achat d’une carte-cadeau',
                    processing: 'En traitement...',
                    payment_information: 'Renseignements de paiement',
                    customer_information: 'Renseignements de client',
                    cc_information: 'Renseignements de Carte de Crédit',
                    price_summary: 'Résumé des prix',
                    total_price: 'Prix total',
                    recommended: 'Recommandée',
                    termsAgreed: 'Veuillez vérifier ceci avant de poursuivre.',
                },
                error_gift_cards: {
                    total: 'Désolé, votre panier est vide. Veuillez ajouter des cartes-cadeaux pour poursuivre.',
                    max2000: 'Désolé ! Il semblerait que le total de votre achat de cartes-cadeaux dépasse le montant maximal autorisé de 2 000 $ pour un achat en ligne. Pour achever votre achat, nous vous invitons à communiquer avec notre Service aux clients au 1 866.969.3325.',
                    ccNumber: 'Votre carte est expirée',
                },
                engine: {
                    filters: 'Filtres',
                    nights_date: "nuits",
                    travel_deals: 'offres de voyages',
                    enter_occupancy: 'VEUILLEZ INSCRIRE VOS DÉTAILS SUR L’OCCUPATION',
                    what_are_child_ages: 'Quel âge ont les enfants au moment du départ?',
                    enter_date: 'Entrez une date',
                    departure_date: 'Date de départ',
                    departing: 'Départ',
                    adults: 'Adultes',
                    cars: 'Voitures',
                    child_age_upon_return: "Âge de l'enfant à son retour",
                    children: 'Enfants',
                    child: 'Enfant',
                    cruises: 'Croisières',
                    days: 'jours',
                    depart: 'Départ',
                    flights: 'Vols',
                    from: 'De',
                    guests: 'Clients',
                    guest: 'Client',
                    hotels: 'Hôtels',
                    hotel: 'Hôtel',
                    loading: 'Chargement...',
                    nights: 'nuits',
                    or: 'ou',
                    return: 'Retour',
                    roomLabel: ':number Chambre:plural',
                    adultLabel: ':number Adult:plural',
                    childrenLabel: ':number Enfants',
                    to: 'à',
                    to_upper: 'À',
                    vacations: 'Vacances',
                    destinations: 'Destinations',
                    destination: 'Destination',
                    all: 'Tous',
                    stars: 'Étoiles',
                    was: 'Était',
                    save: 'Économisez',
                    rooms: 'Chambres',
                    room: 'Chambre',
                    packages: 'Paquets',
                    flight_hotel: 'Vol + Hôtel',
                    please_wait: 'Veuillez patienter pendant que nous recherchons vos meilleurs prix ...',
                    select: 'Sélectionnez',
                    and: 'et',
                    promoCode: 'Code promotionnel',
                    enter_code: 'Entrez le code',
                    advanceSearch: 'Recherche avancée',
                    multipleDestination: 'Planificateur de vacances à destinations multiples',
                    addons: 'Produits optionnels',
                    destination_placeholder: 'Recherche par ville',
                    additionalFlightFilter: 'Filtre de vol supplémentaire',
                    additionalHotelFilter: "Filtre d'hôtel supplémentaire",
                    include_baggage: "Inclure les bagages gratuits",
                    exclude_connections: "Exclure les connexions pendant la nuit",
                    exclude_economy: "Exclure l'économie de base",
                    exclude_non_ref_flights: "Exclure les vols non remboursables",
                    exclude_non_charge_flights: "Exclure les vols non changeables",
                    city_hotel_name: "Entrez le nom de la ville ou de l'hôtel",
                    additionalCarFilter: "Filtre de voiture supplémentaire",
                    clear: "Effacer",
                    clients: "passagers",
                    enter_more_characters: "Entrez un ou plusieurs caractères",
                    no_records_found: "Aucun dossier trouvé",
                    select_travel_dates: "Veuillez sélectionner vos dates de voyage",
                    date_format: 'JJMMMAA',
                    learn_more: 'En savoir davantage!',
                    new: 'Nouveau!',
                    gigi_tool:'Essayez notre nouvel outil GiGi',
                    current_air_tool:'Outil actuel pour les vols',
                    flights_cad:'Vols CA',
                    flights_usd:'Vols US',
                    max_adult_allow: "Vous pouvez sélectionner jusqu'à 12 adultes seulement",
                    max_child_allow: "Vous pouvez sélectionner jusqu'à 6 enfants seulement",
                    max_adult_child_allow: "Vous pouvez sélectionner jusqu'à 12 adultes et 6 enfants seulement.",
                    days_left_to_bye: "jours avant de dire adieu👋🏻"
                },
                engine_travelgenie: {
                    title: 'VoyaGénie',
                    flight_hotel: 'Vol + Hôtel',
                    flight_car: 'Vol + Voiture',
                    from: 'Au départ de',
                    to: 'Vers',
                    departure: 'Départ',
                    return: 'Retour',
                    cabin: 'Classe',
                    roomsnguest: 'Chambres & Passagers',
                    departure_placeholder: "Entrez code d’aéroport ou ville",
                    of_nights: "Nombre de nuits",
                    airline: "Compagnie aérienne",
                    airline_placeholder: "Sélectionnez une compagnie aérienne",
                    number_of_stops: "Nombre d'escales",
                    depart_time: "Heure de départ",
                    select_time: "Sélectionnez l'heure",
                    return_time: "Heure de retour",
                    hotel_placeholder: "Sélectionnez un hôtel",
                    chain: "Chaîne",
                    chain_placeholder: "Sélectionnez une chaîne",
                    booking_an_infant: "Réserver un bébé",
                    adults_children: "Passagers",
                    adults_and_children: "Adultes et enfants",
                    adults: "Adulte(s)",
                    children: "Enfant(s)",
                    booking_an_infant_pera: "Les passagers âgés de moins de 2 ans pendant la durée du séjour sont considérés comme des bébés et peuvent voyager gratuitement (1 bébé par adulte autorisé). Une réservation est toutefois nécessaire pour chaque enfant. Veuillez noter qu'aucun siège n'est attribué aux bébés et qu'ils ne bénéficient pas d'une franchise de bagages. Si un bébé atteint l'âge de 2 ans pendant le voyage, un billet d'avion doit être acheté pour son voyage vers et depuis la destination. Certains frais peuvent s'appliquer.",
                    select_a_departure: "Sélectionnez un point de départ",
                    select_a_destination: "Sélectionnez une destination",
                    please_select_a_valid_departure_and_return_date: "Sélectionnez une date de depart et retour",
                    please_select_a_valid_departure_date: "Veuillez sélectionner une date de départ valide",
                    hrs_error_for_departure_date: "Pour les départs dans les 48 heures, veuillez contacter notre centre d'appel pour réserver",
                },
                engine_cars: {
                    pickup_time: 'Temps de<br/>Ramasser',
                    dropoff_time: 'Temps de<br/>Retour',
                    pickup_location: 'Location<br/>de Ramasser',
                    afternoon: 'Après-midi',
                    different_dropoff: 'Ramasser différent',
                    dropoff: 'Retour',
                    dropoff_date: 'Retour',
                    morning: 'Matin',
                    pickup: 'Ramasser',
                    enter_pickup: 'Entrer le lieu de ramassage',
                    pickup_date: 'Date de<br/>ramassage',
                    evening: 'Soir',
                    car: 'Voiture',
                    car_gross: 'Voiture Brut',
                    car_net: 'Voiture Net',
                    car_company: 'Compagnie de location de voiture',
                    car_pickup: 'Date de prise en charge',
                    car_dropoff: 'Date de retour',
                },
                engine_cruises: {
                    cruise_length: 'Durée de <br>la croisière',
                    departure_port: 'Port de <br>départ',
                    all_destinations: 'Toutes les destinations',
                    all_months: 'Tous les mois',
                    all_vendors: 'Toutes les lignes de croisière / navires',
                    any_duration: 'Toute durée',
                    any_port: 'Tous les ports',
                    destinations: 'Vers',
                    ports: 'Les Ports',
                    vendors: 'Ligne de croisière / navire',
                    month: 'Mois',
                    year: 'Année',
                    ocean: 'Océan',
                    river: 'Fluviale',
                    destination: 'Destination',
                    start: 'du',
                    end: 'au',
                    duration: 'Durée',
                    cruiseLine: 'Ligne de croisière',
                    cruiseShip: 'Navire',
                    embarkationPort: "Port d'embarquement",
                    destination_placeholder: 'Sélectionnez une destination',
                    cruiseLine_placeholder: "Sélectionnez une ligne de croisière",
                    cruisePort_placeholder: 'Sélectionnez un port d’embarquement',
                    cruiseShip_placeholder: 'Sélectionnez un navire',
                    cabins: "de cabine",
                    nights_one_two: "1-2 nuits",
                    nights_three_six: "3-6 nuits",
                    nights_seven_nine: "7-9 nuits",
                    nights_ten_fourteen: "10-14 nuits",
                    nights_fifteen_plus: "15+ nuits",
                    any_lenth: "Toutes les durées"
                },
                engine_flights: {
                    class_first: 'Première Classe',
                    class_business: 'Classe Affaire',
                    class_economy: 'Économique',
                    class_premium_economy: 'Économique Premium',
                    depart: 'Départ',
                    direct_flight: 'Sans escale',
                    multi_city: 'Multi-trajets',
                    nearby_airports: 'Aéroport le plus proche',
                    one_way: 'Aller simple',
                    return: 'Retour',
                    round_trip: 'aller-retour',
                    from_placeholder: 'entrer une ville ou un aéroport',
                    to_placeholder: 'entrer une ville ou un aéroport',
                    enter_date: 'entrer la date',
                    add_flight: 'Ajouter un autre vol',
                    remove_flight: 'Supprimer le dernier vol',
                    multi_city_flight_from: 'Vol multi-villes à partir de',
                },
                engine_hotels: {
                    gross: 'Brut',
                    net: 'Net',
                    vacation_rental: "Locations de vacances",
                    departure: 'Départ',
                    depart: "Date d'arrivée",
                    return: 'Date de départ',
                    destination: 'Vers',

                },
                engine_vacations: {
                    advanced_destination_selection: 'Sélection de destination avancée',
                    select_destination_departing_from: 'Select Destination Departing from FR',
                    select_destination: 'Sélectionnez votre destination ',
                    filter_placeholder: 'Tapez ici pour filtrer la recherche',
                    seat_selection: 'Sélection de sièges gratuites',
                    book_deposit: 'Réserver avec dépôt',
                    per_guest: 'per guest',
                    includes_taxes: 'comprend les taxes et les frais',
                    rooms: 'Chambres',
                    clients: 'Clients',
                    departure_date: 'Date de départ',
                    departing_from: 'Départ de',
                    going_to: 'À destination de',
                    modify_search: 'Modifier votre recherche',
                    all_inclusive_only: 'Tout inclus seulement',
                    depart: 'Départ',
                    loading: 'Chargement...',
                    destination_placeholder: 'Sélectionnez une destination ou hotêl',
                },
                engine_sunquest: {
                    selectDate: 'Sélectionnez date',
                    howLong: 'Durée',
                    destination_placeholder: "Entrez le code de l'aéroport ou la ville",
                    please_select_a_valid_departure_date:"Veuillez sélectionner une date de départ valide",
                },
                engine_packages: {
                    flight_hotel: 'Vol + Hôtel',
                    flight_hotel_car: 'Vol + Hôtel + Voiture',
                    flight_car: 'Vol + Voiture',
                    hotel_car: 'Hôtel + Voiture',
                },
                error: {
                    childAges: "Entrez l'âge de l'enfant :number",
                    date: 'Choisissez une autre date ci-dessous:',
                    departure: 'Sélectionnez un départ',
                    destination: 'Sélectionnez une destination',
                    invalid_dates: 'La date de retour doit être supérieure à la date de départ',
                    please_select_a_valid_departure_and_return_date:'Sélectionnez une date de départ et de retour valide',
                },
                error_cars: {
                    dropoff: 'Sélectionnez un lieu de dépôt',
                    dropoff_date: 'Sélectionnez une date de dépôt',
                    pickup: 'Sélectionnez un lieu de ramassage',
                    pickup_date: 'Sélectionnez une date de ramassage',
                },
                error_cruises: 'error_cruises',
                error_flights: {
                    return_date: 'Sélectionnez une date de retour',
                    travel_date: 'Sélectionnez une date de voyage',
                },
                error_groups: {
                    your_name: 'Veuillez entrer votre nom',
                    your_email: 'Veuillez entrer une adresse courriel valide',
                    your_phone: 'Veuillez entrer votre numéro de téléphone',
                    your_vacation_type: 'Veuillez sélectionner un type de vacances',
                    your_city: 'Veuillez sélectionner une ville de départ',
                },
                error_hotels: {
                    checkin_date: "Entrez une date d'arrivée",
                    checkout_date: 'Entrez une date de départ',
                    childAges: "Entrez l'âge pour l'enfant :number dans la chambre :room",
                    destination: 'Sélectionnez une destination',
                },
                error_vacations: {
                    adultsEven: "Désolé, l'occupation des adultes doit être cohérente pour toutes les chambres dans une réservation en ligne.",
                    depart: 'Départ est requis',
                    fivePerRoom: 'Désolé, vous ne pouvez pas réserver plus de 5 personnes dans une seule pièce.',
                    from: 'Départ est requis',
                    moreThenSix: "Désolé, vous ne pouvez réserver qu'un maximum de 6 passagers dans une réservation en ligne.",
                    multiRoomNoChildren: 'Désolé, vous ne pouvez pas réserver des enfants avec plusieurs pièces. Veuillez appeler toutes les questions.',
                    to: 'À est requis',
                },
                bpc: {
                    best_price_calendar: 'Calendrier des Meilleurs Prix',
                    new: 'Nouveau!',
                    lowest_price_calendar: 'Calendrier des Meilleurs Prix',
                    flexible: 'Flexible avec votre itinéraire?',
                    compare_dates: 'Comparez les dates, destinations et hôtels pour trouver le meilleur temps pour voyager!',
                    select_month: 'Sélectionnez un mois',
                    search_heading: 'Recherchez Notre Calendrier Des Meilleurs Prix',
                    compare_by_resorts: 'Comparez plutôt par Hôtels',
                    check_uncheck_all: 'Cochez / Décochez tous',
                    filter_by: 'Filtrer par',
                    filter_stars: 'Filter Stars',
                    filter_resorts: 'Filter Resorts',
                    search_for_best: 'Recherchez les meilleurs prix',
                    all_inclusive: 'Tout inclus',
                    direct_flight: 'Vol direct',
                    family_friendly: 'Familial',
                    adults_only: 'Adultes seulement',
                    luxury: 'Luxe',
                    beach_front: 'Face à la plage',
                    oceanview: 'Vue mer',
                    golf_course: 'Près d’un golf',
                    kitchenette: 'Cuisinette',
                    miniclub: 'Mini-club',
                    casino: 'Casino',
                    spa: 'Spa',
                    wedding: 'Mariage',
                    classic_view: 'Vue Classique',
                    show_filters: 'Montrer les Filtres',
                    hide_filters: 'Cacher les Filtres',
                    shopping_later: 'Vous voulez continuer de magasiner plus tard? Sauvegarder vos recherches dans votre courriel',
                    duration: 'Durée',
                    star_rating: 'Étoilée',
                    package_options: 'Options de vacance',
                    departure_dates: 'Dates de départ',
                    your_resorts: 'Votre Hôtel',
                    compare_five: 'Vous pouvez comparer les prix pour un maximum de cinq hôtels',
                    departure_month: 'Mois de départ',
                    per_person: 'par personne - comprend les taxes et les frais',
                    list_view: 'Vue de la liste',
                    calendar_view: 'Vue Calendrier',
                    no_results: "Il n'y a pas de résultats. S'il vous plaît essayez une recherche différente.",
                    filter: 'Filtrer',
                    no_departures: 'pas de départs',
                },
                mealDescription: {
                    AI: 'Sont compris tous les jours : tous les repas, les collations, les boissons et volonté (alcoolisées et non-alcoolisées)',
                    AAI: 'Est particulier au centre de villégiature et PEUT inclure 3 repas par jour, les collations et les boissons limitées, sans aucune autre activité',
                    EP: 'Sans les repas et boissons',
                    BP: 'Seul le petit Déjeuner est disponible',
                    MAP: 'Petit Déjeuner et souper seulement',
                    FAP: 'Petit Déjeuner, Déjeuner et souper seulement',
                    FCTC: 'Sont compris tous les jours : tous les repas, les collations, les boissons et volonté (alcoolisées et non-alcoolisées)',
                    PO: 'Seul le petit Déjeuner est disponible',
                    PE: 'Sans les repas et boissons',
                },
                mealContext: {
                    AI: 'Tout inclus',
                    AAI: 'Presque tout inclus',
                    EP: 'Plan européen: sans repas',
                    BP: 'Formule avec petit-déjeuner',
                    MAP: 'Petit-déjeuner et dîner seulement',
                    FAP: 'Petit-déjeuner, déjeuner et diner seulement',
                    FCTC: 'Tout inclus',
                    PO: 'Formule avec petit-déjeuner',
                    PE: 'Plan européen: sans repas',
                },
                loadingModel: {
                    please_wait: 'Veuillez patienter',
                    we_are_processing: 'Nous traitons votre demande.',
                },
                weekOpenDays: {
                    open: 'Ouvert ',
                    close: 'Fermé ',
                    closed: 'Fermé ',
                    Closes: 'Ferme à',
                },
                callcenter: {
                    booking_on_behalf_of: 'Réservation pour le compte de:',
                    type_agency_here: 'Entrez l’agence ici...',
                    select_agent_here: 'Choisir l’agent ici...',
                    no_agent_found: 'Aucun agent trouvé',
                    searching: 'Recherche en cours...',
                    do_you_want_to: 'Voulez-vous réserver pour le compte de',
                    ok: 'OK',
                    CANCEL: 'ANNULER',
                    fetching_data: 'Récupérer les données...',
                    high_risk_agency: 'Agence à haut risque - CC uniquement',
                },
                edocs: {
                    edocs_and_e_invoices: 'Documents électroniques et factures',
                    edocs_merit_golf_ski: 'Edocs / Invoices - Merit Golf and Ski',
                    please_be_advised: "Veuillez noter que même si votre dossier est confirmé, il n'est pas garanti jusqu'à ce que nous recevions le paiement à notre bureau. Vous ne pourrez pas accéder aux documents de vos clients tant que le paiement n'aura pas été reçu.",
                    edocs_are_available: 'Les e-docs sont disponibles à 45 jours du départ à condition que le dossier soit payé en totalité.',
                    last_minute_bookings: "Les e-docs pour les réservations de dernière minute peuvent prendre jusqu'à 24 h pour être accessibles.",
                    if_you_have_made: "Si vous avez modifié une réservation, veuillez noter que l'icône e-doc sera estompé jusqu'à ce que les nouveaux documents soient prêts.",
                    if_your_file_meets: "Si les e-docs de votre réservation ne sont pas accessibles et qu'ils le devraient selon les informations ci-dessus, veuillez envoyer un courriel à ",
                    booking_number: "Numéro de réservation",
                    lead_pax_name: "Nom du responsable PAX",
                    Please_fill: "Veuillez indiquer le numéro de réservation ou le nom de l'organisateur.",
                    booking_date_from: "Date de réservation du",
                    booking_date_to: "Date de réservation jusqu'au",
                    departure_date_from: "Date de départ De",
                    departure_date_to: "Date de départ Jusqu'à",
                    valid_date: "Veuillez remplir la date valide",
                    search: 'Recherche',
                    or: 'OU',
                    lead_pax_last_name: "Saisir le nom de famille du chef de file PAX",
                    tb_booking_number: "Saisir le numéro de Réservation TravelBrands",
                    enter_agency_number: "Saisir le numéro de Téléphone de l'agence",
                    agency: "Agence",
                    fill_agency_phone: "Veuillez remplir le numéro de téléphone de l'agence",
                    origin: "Origine",
                    enter_origin: "Entrez l'origine",
                    destination: "Destination",
                    enter_destination: "Entrez la destination",
                    booking: "Réservation",
                    username: "Nom d'utilisateur",
                    departure_date: "Date de départ",
                    e_invoice_english: "Facture électronique en anglais",
                    e_invoice_french: "Facture électronique en français",
                    e_ticket: "Billet électronique",
                    rows_per_page: "Lignes par page",
                    no_record: "Il n'y a pas de dossiers à afficher",
                    oops_message: "Oups ! Quelque chose n'a pas fonctionné. Veuillez réessayer plus tard.",
                    email_success: "Le courriel a été envoyé avec succès !",
                    valid_email: "Veuillez remplir l'email valide",
                }
            },
        };
        this.all = all;
        // this.loadFiles();
    }

    currency(n, decimals, showCurrency) {
        let price = parseFloat(n);
        let currencyCode = '';
        if (decimals !== undefined && decimals) {
            price = price.toFixed(2);
        }

        if (showCurrency !== undefined && showCurrency) {
            currencyCode = 'C';
        }

        if (window.Locale === 'en') {
            return `${currencyCode}$${price}`;
        }
        return `${currencyCode}${price}$`;
    }

    addListener(f) {
        this.listeners.push(f);
    }

    trans(hash, data = null) {
        // return hash;
        const commands = hash.split('.');
        const app = document.getElementById('app');
        const { language } = app.dataset;
        const langData = this.data[language];

        if (Object.prototype.hasOwnProperty.call(langData, commands[0]) && Object.prototype.hasOwnProperty.call(langData[commands[0]], commands[1])) {
            let s = langData[commands[0]][commands[1]];


            // If data object is set - use key/values and replace the key in the language string
            if (data !== null) {
                for (const key in data) {
                    s = s.replace(new RegExp(`:${key}`, 'i'), data[key]);
                }
            }


            // return `[${s}]`;
            return s;
        }
        console.log(hash, 'lang entry not found');

        return hash;
    }
}

const inst = new Lang();
export default inst;